import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import PropTypes from "prop-types";
import { Button, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import VivoAvatar from "@assets/img/avatar.png";
import { useHistory } from "react-router";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles(() => ({
  image: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  grid: {
    justifyContent: "center",
    alignItems: "center",
  },
}));

function ServiceInfo(props) {
  const classes = useStyles();

  const history = useHistory();

  function handleClose() {
    history.push("/login");
  }

  function handleAgree() {
    history.push("/login/contato");
  }

  return (
    <Dialog
      open={props.open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      maxWidth="md"
    >
      <DialogTitle>Ainda não adquiriu este serviço?</DialogTitle>
      <DialogContent>
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} sm={8}>
            <Typography>
              Você já pensou em acionar equipes técnicas, convocar
              reuniões,comunicação com força de vendas, através de mensagens de
              texto para celular?
            </Typography>
            <Typography>
              Com o Torpedo Empresas, a comunicação de sua empresa fica muito
              mais ágil, fácil e confiável. As mensagens são enviadas com toda
              agilidade, segurança e precisão que o mundo corporativo precisa. E
              você ainda pode controlar e gerenciar a entrega destas mensagens.
            </Typography>
            <Typography>
              Além disso, é possível integrar os sistemas da sua empresa
              (servidor de e-mails, ferramentas de gestão, ferramentas de CRM,
              entre outros) aos telefones celulares dos seus funcionários,
              permitindo que as mensagens sejam enviadas com precisão.
              Comunicação fácil e imediata para sua empresa ganhar tempo.
            </Typography>
            <Typography>
              O serviço permite o envio simultâneo de mensagens de texto
              (Torpedos SMS) para grupos de celulares, transformando os
              celulares de seus profissionais em poderosas ferramentas de
              comunicação e integração.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <div className={classes.image}>
              <img
                src={VivoAvatar}
                alt="Avatar da Vivo"
                height="200px"
                width="200px"
              />
            </div>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose()}>Depois</Button>
        <Button onClick={() => handleAgree()} color="primary">
          Quero contratar agora
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ServiceInfo.propTypes = {
  open: PropTypes.bool.isRequired,
};

ServiceInfo.defaultProps = {
  open: false,
};

export default ServiceInfo;
